<template>
  <div>
    <GNDownPC v-if="site==='gn'"></GNDownPC>
    <BNDownPC v-else-if="site==='bn'"></BNDownPC>
    <MNDownPC v-else-if="site==='mn'"></MNDownPC>
    <GFDownPC v-else-if="site==='gf'"></GFDownPC>
    <GRDownPC v-else-if="site==='gs'"></GRDownPC>
  </div>
</template>

<script>
import GNDownPC from './gn/Down.vue';
import BNDownPC from './bn/Down.vue';
import MNDownPC from './mn/Down.vue';
import GFDownPC from './gf/Down.vue';
import GRDownPC from './gr/Down.vue';
export default {
  name: "PCHome",
  inject: ["home"],
  components: {
    GNDownPC,
    BNDownPC,
    MNDownPC,
    GFDownPC,
    GRDownPC,
  },
  mounted() {

  },
  computed: {
    site() {
      return this.home.extendObj.site;
    }
  }
}
</script>

<style lang="scss">
.pc {
  font-size: 20px;
}
</style>